export default {"src":"/_next/static/media/Maaran_colour_white_with tag.4e683f86.svg","height":781,"width":3685,"blurWidth":0,"blurHeight":0};